import { c as _c } from "react/compiler-runtime";
interface CoverProps {
  ready: boolean;
}
export function TrailerCover(t0) {
  const $ = _c(2);
  const {
    ready
  } = t0;
  const t1 = ready ? 0 : 1;
  let t2;
  if ($[0] !== t1) {
    t2 = <div className="absolute inset-0 bg-black transition-opacity duration-300 pointer-events-none" style={{
      opacity: t1,
      zIndex: 5
    }} />;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  return t2;
}
export function TrailerLoading() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="absolute inset-0 z-10 flex flex-col items-center justify-center gap-3 text-white"><div className="w-8 h-8 border-4 border-white/20 border-t-white rounded-full animate-spin" /><span className="text-sm">در حال بارگذاری...</span></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}
interface ErrorProps {
  message: string;
  onRetry: () => void;
}
export function TrailerError(t0) {
  const $ = _c(7);
  const {
    message,
    onRetry
  } = t0;
  let t1;
  if ($[0] !== message) {
    t1 = <p className="text-red-400 text-sm">{message}</p>;
    $[0] = message;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== onRetry) {
    t2 = <button onClick={onRetry} className="px-4 py-2 bg-white/20 rounded-lg hover:bg-white/30 transition text-sm">تلاش مجدد</button>;
    $[2] = onRetry;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <div className="absolute inset-0 z-10 flex flex-col items-center justify-center gap-4 text-white">{t1}{t2}</div>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}